import PictureFalls from "../components/PictureFalls";

export default function PageLibPictures() {
  return (
    <PictureFalls
      title="图片列表"
      allowImport
      allowRename
      allowReplace
      allowDelete
      columnWidth={256}
    />
  );
}
